import { Alert, Button, LinearProgress, Stack, Typography } from '@mui/material';

import { useListAdminEhrUploadsQuery } from '../../store/ehrApi';

import { EhrUploadList } from './EhrUploadList';
import { StoredEhrFiles } from './StoredEhrFiles';

export function AdminEhrMigrationPanel({
  organizationId,
  enabled = false,
}: {
  organizationId: string;
  enabled?: boolean;
}) {
  return enabled ? (
    <AdminEhrMigrationContent key={organizationId} organizationId={organizationId} />
  ) : null;
}

function AdminEhrMigrationContent({ organizationId }: { organizationId: string }) {
  const query = useListAdminEhrUploadsQuery(
    { organizationId },
    { refetchOnMountOrArgChange: true },
  );
  return (
    <Stack spacing={2}>
      <Typography variant="h6">Organization EHR migration</Typography>
      <Typography color="text.secondary">
        Import and review the source batch in Data Import. Progress follows that import’s status.
        This status applies to the organization.
      </Typography>
      {query.isLoading && <LinearProgress aria-label="Loading EHR uploads" />}
      {query.isError && (
        <Alert
          severity="error"
          action={<Button onClick={() => void query.refetch()}>Retry</Button>}
        >
          Could not load this organization’s EHR uploads.
        </Alert>
      )}
      {!query.isLoading && !query.isError && (
        <EhrUploadList
          uploads={query.currentData?.uploads ?? []}
          renderFiles={upload => (
            <StoredEhrFiles
              staff
              uploadId={upload.upload_id}
              revision={upload.inventory_updated_at ?? upload.status}
              organizationId={organizationId}
            />
          )}
          dataImportUrl={upload =>
            `/admin-v2/organization/${encodeURIComponent(organizationId)}?tab=data-import&rawUploadId=${encodeURIComponent(upload.upload_id)}`
          }
        />
      )}
      <Button
        sx={{ alignSelf: 'flex-start' }}
        disabled={query.isFetching}
        onClick={() => void query.refetch()}
      >
        Refresh uploads
      </Button>
    </Stack>
  );
}
